module.exports = __webpack_public_path__ + "img/dance-test-icon4.cb71dc6f.png";